import { IMAGE_FIT_TYPES } from '../../../constants/file'
import { isGifFile } from '../../../utils/file'

import { THUMBNAIL_SIZE_1020 } from './FileListItem.constants'

export function getFileSrc(file, isGallery) {
  if (isGifFile(file)) {
    return file.origin || file.thumbnail
  }

  return isGallery ? file.thumbnails[THUMBNAIL_SIZE_1020] : file.thumbnail
}

export function getImageFit({ height, width }) {
  const containAll =
    !width ||
    !height ||
    width < THUMBNAIL_SIZE_1020 ||
    height < THUMBNAIL_SIZE_1020

  return containAll
    ? IMAGE_FIT_TYPES.containAll
    : IMAGE_FIT_TYPES.containVertical
}
